export default "__VITE_ASSET__21c1f196__"